module.exports = __webpack_public_path__ + "static/media/keyFeature1.ad7720f1.png";